const profiles = {
  inverted: {
    bkg: '#f5f5f5',
    highlight: '#fff',
    shadow: '#CCE5E1',
  },
  teal: {
    large: {
      bkg: '#019f8e',
      highlight: '#00d8c0',
      shadow: '#00766a',
      text: '#008575',
    },
    small: {
      bkg: '#008575',
      highlight: '#00C8B0',
      shadow: '#006256',
      text: '#006256',
    },
  },
  orange: {
    large: {
      bkg: '#EC7000',
      highlight: '#FFC360',
      shadow: '#B94700',
      text: '#C7530A',
    },
    small: {
      bkg: '#C7530A',
      highlight: '#E96D27',
      shadow: '#A74000',
      text: '#A74000',
    },
  },
  purple: {
    large: {
      bkg: '#B272EF',
      highlight: '#D9B6FA',
      shadow: '#872CDE',
      text: '#9942ED',
    },
    small: {
      bkg: '#9942ED',
      highlight: '#D9B6FA',
      shadow: '#760DDA',
      text: '#760DDA',
    },
  },
  indigo: {
    large: {
      bkg: '#7365FF',
      highlight: '#949EFF',
      shadow: '#5046FF',
      text: '#6455FF',
    },
    small: {
      bkg: '#6455FF',
      highlight: '#949EFF',
      shadow: '#3F35EF',
      text: '#423BC9',
    },
  },
  coral: {
    large: {
      bkg: '#E56446',
      highlight: '#FDA381',
      shadow: '#A72F02',
      text: '#D63F1C',
    },
    small: {
      bkg: '#D63F1C',
      highlight: '#FF7D5F',
      shadow: '#A22C00',
      text: '#9A2500',
    },
  },
};

export const getColorProfile = ({ colorSet = 'teal', size = 'large', invert = false }) => {
  if (invert) {
    return {
      ...profiles.inverted,
      text: profiles[colorSet][size === 'medium' ? 'large' : size].text,
    };
  }

  return {
    ...profiles[colorSet][size === 'medium' ? 'large' : size],
    text: '#ffffff',
  };
};

export default getColorProfile;
